import { HILOConfig, Options } from '../overlays/configs/hilo'
import utils from '../utils'
import { MainCalculation } from './main'

type DefaultCalculatedValuesType = {
  high: number[]
  low: number[]
  previousHigh: number[]
  previousLow: number[]
}

export class HILOCalculation extends MainCalculation<Options, DefaultCalculatedValuesType> {
  static config = HILOConfig

  calculate() {
    const { period, calculatePrevious } = this.options
    const { high, low, close } = this.quote
    this._calculatedValues = this.getDefaultCalculatedValues()

    if (close.length === 0) return

    const endIndex = close.length - 1
    const startingIndex = period > close.length ? close.length - 1 : period - 1

    for (let i = startingIndex; i <= endIndex; i++) {
      const sliceStart = Math.max(0, i - startingIndex)
      const sliceEnd = i + 1
      const highInPeriod = utils.max(high.slice(sliceStart, sliceEnd))
      const lowInPeriod = utils.min(low.slice(sliceStart, sliceEnd))

      this._calculatedValues.high[i] = highInPeriod
      this._calculatedValues.low[i] = lowInPeriod

      // In fiters itteration, we want to populate the previous values with same values
      if (i === startingIndex) {
        let previousHighInPeriod = highInPeriod
        let previousLowInPeriod = lowInPeriod

        if (calculatePrevious) {
          previousHighInPeriod = utils.max(high.slice(sliceStart, Math.max(0, sliceEnd - 1)))
          previousLowInPeriod = utils.min(low.slice(sliceStart, Math.max(0, sliceEnd - 1)))
        }

        for (let j = 0; j < startingIndex; j++) {
          this._calculatedValues.high[j] = highInPeriod
          this._calculatedValues.low[j] = lowInPeriod
          if (calculatePrevious) {
            this._calculatedValues.previousHigh[j] = previousHighInPeriod
            this._calculatedValues.previousLow[j] = previousLowInPeriod
          }
        }
      }

      if (calculatePrevious && i < endIndex) {
        this._calculatedValues.previousHigh[i] = highInPeriod
        this._calculatedValues.previousLow[i] = lowInPeriod
      }
    }
  }
}
